<template>
  <p
    v-show="show"
    tabindex="-1"
    :ref="uid"
    class="pb-0 mb-1 ml-2 mr-2 pa-1"
    v-text="description"
  ></p>
</template>

<script>
export default {
  name: "FilterDescription",
  props: {
    show: Boolean,
    title: String,
    description: String,
  },
  watch: {
    show: function(newVal) {
      if (newVal) {
        this.$nextTick(() => this.$refs[this.uid].focus());
      }
    },
  },
};
</script>

<style></style>
